import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  getSelectedFacets,
  getSelectedPriceRangeFacet,
  applyFacets
} from "../../state/modules/search";
import { UPDATE_MULTI_FACET } from "../../state/modules/search/constants";
import { analyticsAddPendingRefinementsToggled } from "../../state/modules/analytics/actions";
import SelectedFacets from "../../components/SelectedFacets";
import { getSelectedFacetValues } from "../../state/modules/search/selectors";
import { withTranslation } from "../../components/translation";
import { clearAlwaysApply } from "../../state/modules/search/actions";
import { isLargeMediumViewPort } from "../../state/modules/search/viewportHelper";

const changeMultiFacetAndApply = toggledFacets => (dispatch, getState) => {
  const normalized = toggledFacets.map(({ facet, facetValue, isSelected }) => ({
    facetId: facet.id,
    valueId: facetValue.id,
    isSelected
  }));

  const state = getState();
  const isMobile = !isLargeMediumViewPort(state);

  dispatch({
    type: UPDATE_MULTI_FACET,
    payload: normalized,
    meta: {
      originalToggles: toggledFacets,
      skipDebounce: isMobile
    }
  });

  dispatch(analyticsAddPendingRefinementsToggled(toggledFacets));

  if (isMobile) {
    dispatch(applyFacets());
  }
};

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        changeMultiFacet: changeMultiFacetAndApply,
        clearAlwaysApply
      },
      dispatch
    )
  };
}

function mapStateToProps(state) {
  const selectedFacetValues = getSelectedFacetValues(state);
  const priceRangeFacet = getSelectedPriceRangeFacet(state);

  const displayedFacetValues = priceRangeFacet
    ? [...selectedFacetValues, priceRangeFacet]
    : selectedFacetValues;

  return {
    selectedFacets: getSelectedFacets(state),
    selectedFacetValues: displayedFacetValues
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation(SelectedFacets));
